export const commway = {
  //组件共用属性
  data() {
    return {};
  },
  methods: {
    //复制
    copyBtn(val) {
      // 仅复制需要的纯文本：若以数字开头且后续包含括号信息（如：19177288485（广西-柳州）），只取前面的连续数字
      let copyText = val;
      if (typeof val === "string") {
        const trimmed = val.trim();
        // 提取开头连续的数字（支持+开头的国际号），仅当后续出现括号或非数字说明信息时生效
        const leadingDigits = trimmed.match(/^\+?\d+/);
        if (leadingDigits && /[()（）]/.test(trimmed)) {
          copyText = leadingDigits[0];
        } else {
          copyText = trimmed;
        }
      } else if (val !== null && val !== undefined) {
        copyText = String(val);
      } else {
        copyText = "";
      }

      const input = document.createElement("input"); //创建input
      input.setAttribute("value", copyText); //把input设置value
      document.body.appendChild(input); //添加这个dom对象
      input.select(); //选中该输入框
      document.execCommand("copy"); //复制该文本
      document.body.removeChild(input); //移除输入框
      this.$tbMessage({
        text: this.$t
          ? this.$t(
              "pages.details.addressDetails.addressTableThird.copySuccess"
            )
          : "复制成功",
        type: "success",
        duration: 1000,
      });
    },
    formatNumber(num) {
      if (num === null || num === undefined) return "-";

      const absNum = Math.abs(num);
      if (absNum >= 1_000_000_000) {
        return (num / 1_000_000_000).toFixed(2) + "B";
      } else if (absNum >= 1_000_000) {
        return (num / 1_000_000).toFixed(2) + "M";
      } else if (absNum >= 1_000) {
        return (num / 1_000).toFixed(2) + "K";
      } else {
        return num.toString();
      }
    },
    // copyBtn() {
    //   var clipboard = new Clipboard(".el-icon-document-copy");
    //   clipboard.on("success", (e) => {
    //     // 释放内存
    //     this.$notify({
    //       message: "复制成功",
    //       type: "success",
    //       duration: 1000,
    //     });
    //     clipboard.destroy();
    //   });
    //   clipboard.on("error", (e) => {
    //     // 不支持复制
    //     //console.log(e);

    //     //console.log("该浏览器不支持自动复制");
    //     // 释放内存
    //     clipboard.destroy();
    //   });
    // },
  },
};
